import { Directive, forwardRef } from '@angular/core';
import { FormLayout } from './form-layout';
import { CapFormColumnsDirective } from './form-columns.directive';

@Directive({
  selector: 'cap-form-row',
  host: {
    class: 'row d-flex flex-row flex-wrap bsg-form-group'
  },
  providers: [{ provide: FormLayout, useExisting: forwardRef(() => CapFormRowDirective) }]
})
export class CapFormRowDirective extends CapFormColumnsDirective {
  constructor() {
    super();
  }

  groupClasses = '';
}
